/*
Copyright (C) 2020 Broadleaf Commerce.

Licensed under the Broadleaf End User License Agreement (EULA),
Version 1.1 (the “Commercial License” located at
http://license.broadleafcommerce.org/commercial_license-1.1.txt).

Alternatively, the Commercial License may be replaced with a mutually
agreed upon license (the “Custom License”) between you and
Broadleaf Commerce. You may not use this file except in compliance
with the applicable license.
*/

import { getCustomersEndpoint } from '@src/oms/InvoicesView/utils/InvoicesOperationUtils';
import { useCallback, useState } from 'react';
import { request } from '@broadleaf/admin-components/dist/metadata/utils/request';
import { ICustomer } from '@src/oms/utils/RmCustomerUtils';
import { Page } from '@broadleaf/admin-components/dist/types/collection';

type Response = {
  fetchCustomers: (
    filter: string,
    contextParams: any
  ) => Promise<Page<ICustomer>>;
  isLoading: boolean;
};

export default function useFetchCustomers(): Response {
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const fetchCustomers = useCallback(
    async (filter, contextParams) => {
      if (isLoading) {
        return;
      }

      setIsLoading(true);
      try {
        const endpoint = getCustomersEndpoint();
        const { data } = await request(
          {
            ...endpoint,
            params: {
              cq: filter
            }
          },
          contextParams
        );
        return data;
      } finally {
        setIsLoading(false);
      }
    },
    [isLoading]
  );

  return { fetchCustomers, isLoading };
}
